import { DEFAULT_ERROR } from '@/constants/errors';
import { FetchDataState, MultiFetchDataState } from '@/types/fetchDataState';
import { NewReaction } from '@/types/models';
import { HighlightReactionDataState, ReactionsState } from './reactions.types';

export const REACTIONS_STATE_INITIAL_MOCK: ReactionsState = {
  highlight: {
    data: [],
    loading: 'idle',
    error: DEFAULT_ERROR,
  },
  data: {},
};

export const REACTIONS_STATE_INITIAL_DATA_MOCK: FetchDataState<Array<NewReaction>> = {
  data: [],
  loading: 'idle',
  error: DEFAULT_ERROR,
};

export const HIGHLIGHT_REACTIONS_INITIAL_STATE_MOCK: MultiFetchDataState<
  Array<HighlightReactionDataState>
> = {
  data: [],
  loading: 'idle',
  error: DEFAULT_ERROR,
};
